import React, { FC, ReactNode } from "react";
import { Avatar, Box, Checkbox, ListItemText, MenuItem } from "@mui/material";
import { capitalize } from "lodash";
import { useField } from "formik";
import { CustomFieldSelect } from "../../../components/fields/CustomFieldSelect";

interface Option {
  label: string;
  value: string | number;
  avatar?: string;
}

interface Props {
  renderValue?: (value: Array<string | number>) => ReactNode;
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  options: Array<string | Option>;
  disabled?: boolean;
  noLabel?: boolean;
  onChange?: any;
  inputProps?: any;
}

export const CustomSelectField: FC<Props> = ({
  label,
  required = true,
  options,
  placeholder,
  disabled,
  noLabel,
  ...rest
}) => {
  const [field] = useField(rest.name);

  const safeOptions = Array.isArray(options) ? options : [];

  return (
    <CustomFieldSelect
      {...rest}
      multiple={!!rest.renderValue}
      label={noLabel ? "" : label || capitalize(rest.name)}
      fullWidth
      required={required}
      placeholder={placeholder || "Select"}
      value={rest.renderValue ? (field.value || []) : (field.value || "")}
      disabled={disabled}
    >
      {safeOptions.map((option, index) => {
        const isObject = typeof option === "object";
        const value = isObject ? option.value : option;
        const displayLabel = isObject ? option.label : option;
        const avatar = isObject ? (option as Option).avatar : undefined;

        if (rest.renderValue)
          return (
            <MenuItem value={value} key={index}>
              <Checkbox checked={field.value?.indexOf(value) > -1} />
              <ListItemText primary={displayLabel} />
            </MenuItem>
          );

        if (avatar !== undefined)
          return (
            <MenuItem value={value} key={index}>
              <Box component="span" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar variant="rounded" src={avatar || undefined} sx={{ width: 22, height: 22, borderRadius: "5px" }}>
                  {String(displayLabel).charAt(0)}
                </Avatar>
                {displayLabel}
              </Box>
            </MenuItem>
          );

        return (
          <MenuItem value={value} key={index}>
            {displayLabel}
          </MenuItem>
        );
      })}
    </CustomFieldSelect>
  );
};
